import { render, staticRenderFns } from "./tbjm.vue?vue&type=template&id=16332574"
import script from "./tbjm.vue?vue&type=script&lang=js"
export * from "./tbjm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports